export default __webpack_public_path__ + "static/media/lunch.209a2912.svg";